import { PRODUCT_VIEW_DATA } from "../../Common/ProductView.constants";
import TopTenants from "../../Common/TopTenants";

export const OpportunityTenantsTab = () => (
  <TopTenants
    paginationModel={PRODUCT_VIEW_DATA.TABS.TAB.OPPORTUNITY_TENANTS.PAGINATION_MODEL}
    pageSizeOptions={PRODUCT_VIEW_DATA.TABS.TAB.OPPORTUNITY_TENANTS.PAGE_SIZE_OPTIONS}
  />
);
